import styled from 'styled-components';

import { Heading } from '@cognite/cogs-core-v11/tokens/typography/typography.tsx';

export const MessageContentWrapper = styled(Heading).attrs({ level: 6 })`
  display: inline-block;
  max-width: 100vw;
`;
